import { EVENT_BROWSE, EVENT_DISPLAYED } from "../../Layout/PhotoGallery";
import HandlerAbstract from "./HandlerAbstract";

export default class PhotoGalleryHandler extends HandlerAbstract {

    _stepReached = {};

    _hasAlreadyBeenFullscreen = {};

    getEventHandlers() {
        return [EVENT_BROWSE, EVENT_DISPLAYED];
    }

    handle(evt) {
        this._analytics.pubSub.publish(evt.type, evt.data);
    }

}
